<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/espace-client" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour a l'espace client</a>
      <span class="crumb-current">Transfert d'argent</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Transactions</p>
        <h1>Transférer des fonds</h1>
        <p class="lead">Envoyez des fonds vers un compte personnel ou professionnel en toute sécurité.</p>
        <div class="pill-row">
          <span class="pill pill-strong">{{this.userSessionService.getUser().firstname}}</span>
          <span class="pill">{{this.userSessionService.getDisplayPrimaryAccountNumber()}}</span>
          <span class="pill">{{this.userSessionService.getDisplayPrimaryAccountBalance()|
            currency:this.userSessionService.getSigle()}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="alerts mb-3">
    <p *ngIf="phoneNotConfirm" class="alert-text danger">Vous devez confirmer votre numéro de téléphone.</p>
    <p *ngIf="CNINotConfirm" class="alert-text danger">Identité non confirmée ou en cours de confirmation.</p>
    <p *ngIf="succes" class="alert-text success">Le transfert a été effectué.</p>
    <p *ngIf="isphone" class="alert-text danger">Destinataire introuvable.</p>
    <p *ngIf="isSecuritypin" class="alert-text danger">Mauvais code de sécurité.</p>
    <p *ngIf="isSolde" class="alert-text danger">Solde insuffisant.</p>
    <p *ngIf="notPermited" class="alert-text danger">Opération non autorisée.</p>
  </div>

  <div class="card-glass p-3">
    <ul class="nav nav-pills glass-tabs" id="transfertTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="part-tab" data-bs-toggle="tab" data-bs-target="#part" type="button"
          role="tab" aria-controls="part" aria-selected="true">Particulier</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="pro-tab" data-bs-toggle="tab" data-bs-target="#pro" type="button" role="tab"
          aria-controls="pro" aria-selected="false">Professionnel</button>
      </li>
    </ul>

    <div class="tab-content mt-3" id="transfertTabsContent">
      <div class="tab-pane fade show active" id="part" role="tabpanel" aria-labelledby="part-tab">
        <div class="card card-glass border-0">
          <div class="card-body">
            <h5 class="mb-3">Transfert de Particulier à Particulier</h5>
            <div *ngIf="loader" id="loader"></div>
            <div class="stepper">
              <div class="step" [class.active]="partStep>=1">1</div>
              <div class="step" [class.active]="partStep>=2">2</div>
              <div class="step" [class.active]="partStep>=3">3</div>
            </div>
            <form [formGroup]="transfert" #f="ngForm" (ngSubmit)="envoyer(f.value)" class="row g-3">
              <div class="col-12" *ngIf="partStep===1">
                <label class="form-label">Compte personnel destinataire</label>
                <input formControlName="numero" type="text" class="form-control" id="emaildestinataire1">
              </div>
              <div class="col-12" *ngIf="partStep===2">
                <label class="form-label">Code de sécurité</label>
                <input formControlName="securitypin" #securityPin (blur)="isSecurityPin(securityPin.value)" type="text"
                  class="form-control" id="secretPin2">
              </div>
              <ng-container *ngIf="partStep===3">
                <div class="col-12">
                  <label class="form-label">Montant {{sigle}}</label>
                  <input formControlName="montan" #montan type="number" (blur)="comparewithsolde(montan.value)"
                    class="form-control" id="montan">
                </div>
                <div class="col-12">
                  <label class="form-label">Usage prévu</label>
                  <input formControlName="motif" type="text" class="form-control" id="motif">
                </div>
                <div class="col-12">
                  <div class="summary-card">
                    <p class="summary-title">Récapitulatif</p>
                    <div class="summary-line"><span>Destinataire
                        :</span><strong>{{transfert.get('numero')?.value}}</strong></div>
                    <div class="summary-line"><span>Montant :</span><strong>{{transfert.get('montan')?.value || 0 |
                        currency:this.userSessionService.getSigle()}}</strong></div>
                    <div class="summary-line"><span>Taxe (0,2%) :</span><strong>{{getPartTransferTaxAmount() |
                        currency:this.userSessionService.getSigle()}}</strong></div>
                    <div class="summary-line"><span>Total débité :</span><strong>{{getPartTransferTotalDebit() |
                        currency:this.userSessionService.getSigle()}}</strong></div>
                    <div class="summary-line"><span>Motif :</span><strong>{{transfert.get('motif')?.value ||
                        '—'}}</strong></div>
                  </div>
                </div>
              </ng-container>
              <div class="d-flex justify-content-between mt-2">
                <button type="button" class="btn btn-secondary btn-pill" (click)="prevPartStep()"
                  [disabled]="partStep===1">Précédent</button>
                <button *ngIf="partStep<3" type="button" class="btn btn-primary btn-pill"
                  (click)="nextPartStep()">Suivant</button>
                <button *ngIf="partStep===3" type="submit" class="btn btn-primary btn-pill"
                  [disabled]="!transfert.valid">Envoyer</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="pro" role="tabpanel" aria-labelledby="pro-tab">
        <div class="card card-glass border-0">
          <div class="card-body">
            <h5 class="mb-3">Transfert vers compte professionnel</h5>
            <div *ngIf="loader" id="loader"></div>
            <div class="mb-2">
              <p *ngIf="emeteur" class="text-danger">Vérifiez que votre numéro de compte est exact.</p>
              <p *ngIf="destinataire" class="text-danger">Le partenaire est introuvable.</p>
              <p *ngIf="succesb" class="text-success">Transfert effectué avec succès.</p>
            </div>
            <div class="stepper">
              <div class="step" [class.active]="proStep>=1">1</div>
              <div class="step" [class.active]="proStep>=2">2</div>
              <div class="step" [class.active]="proStep>=3">3</div>
            </div>
            <form [formGroup]="transfertb" #b="ngForm" (ngSubmit)="sendToBaccount(b.value)" class="row g-3">
              <ng-container *ngIf="proStep===1">
                <div class="col-md-6">
                  <label class="form-label">Choix du transfert</label>
                  <select class="form-select" id="exampleFormControlSelect1" (change)="typchange($event.target.value)">
                    <option value="">---</option>
                    <option value="1">De Personnel à affaire</option>
                    <option value="2">De Professionnel à Professionnel</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Votre numéro de compte {{typcomte}}</label>
                  <input formControlName="baccounte" type="text" class="form-control" id="baccounte">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Numéro de compte affaire partenaire</label>
                  <input formControlName="baccountd" type="text" class="form-control" id="baccountd">
                </div>
              </ng-container>
              <div class="col-md-6" *ngIf="proStep===2">
                <label class="form-label">Code de sécurité</label>
                <input formControlName="codepin" #securityPinb (blur)="isSecurityPinB(securityPinb.value)" type="text"
                  class="form-control" id="secretPin2">
              </div>
              <ng-container *ngIf="proStep===3">
                <div class="col-md-6">
                  <label class="form-label">Montant (FCFA)</label>
                  <input formControlName="montant" #montant type="number" class="form-control" id="montant">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Usage prévu</label>
                  <input formControlName="motif" type="text" class="form-control" id="motif">
                </div>
                <div class="col-12">
                  <div class="summary-card">
                    <p class="summary-title">Récapitulatif</p>
                    <div class="summary-line"><span>Type :</span><strong>{{typcomte || '—'}}</strong></div>
                    <div class="summary-line"><span>Compte émetteur :</span><strong>{{transfertb.get('baccounte')?.value
                        || '—'}}</strong></div>
                    <div class="summary-line"><span>Compte affaire :</span><strong>{{transfertb.get('baccountd')?.value
                        || '—'}}</strong></div>
                    <div class="summary-line"><span>Montant :</span><strong>{{transfertb.get('montant')?.value || 0 |
                        currency:this.userSessionService.getSigle()}}</strong></div>
                    <div class="summary-line"><span>Taxe (0,2%) :</span><strong>{{getProTransferTaxAmount() |
                        currency:this.userSessionService.getSigle()}}</strong></div>
                    <div class="summary-line"><span>Total débité :</span><strong>{{getProTransferTotalDebit() |
                        currency:this.userSessionService.getSigle()}}</strong></div>
                    <div class="summary-line"><span>Motif :</span><strong>{{transfertb.get('motif')?.value ||
                        '—'}}</strong></div>
                  </div>
                </div>
              </ng-container>
              <div class="d-flex justify-content-between mt-2">
                <button type="button" class="btn btn-secondary btn-pill" (click)="prevProStep()"
                  [disabled]="proStep===1">Précédent</button>
                <button *ngIf="proStep<3" type="button" class="btn btn-primary btn-pill"
                  (click)="nextProStep()">Suivant</button>
                <button *ngIf="proStep===3" type="submit" class="btn btn-primary btn-pill"
                  [disabled]="!transfertb.valid || loader">Envoyer</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
